import { useMemo } from 'react';
import { getNames, registerLocale } from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';

registerLocale(en);

export const useCountryOptions = (locale = 'en') => {
  const processedCountries = useMemo(
    () => [
      {
        title: 'Choose country',
        value: '',
      },
      // all countries in the correct format
      ...Object.entries(getNames(locale))
        // convert each country to { title, value } format for FormSelect
        .map(([code, name]) => ({
          title: name,
          value: code,
        }))
        // sort by country name
        .sort((a, b) => a.title.localeCompare(b.title)),
    ],
    [locale],
  );

  return processedCountries;
};
